export class GeneralViewStateTypes {
    public static SINGLE: number = 0;
    public static SINGLEFEED: number = 2;
    public static MULTIPLEFEED: number = 3;
}

export class ViewStateTypes {
    public static SYSTEM: number = -1;
    public static TOPIC: number = 0;
    public static ASSIGNMENT: number = 1;
    public static SEARCH: number = 2;
    public static SINGLEITEM: number = 4;
    public static SCRIPT: number = 5;

    public static WIRE: number = 200;
    public static WIRESEARCH: number = 201;

    public static SINGLEFEED: number = 202;
    public static MULTIPLEFEED: number = 203;

    public static RSSFEED: number = 204;
    public static TWITTERFEED: number = 205;
    public static WIREFEED: number = 206;
    public static EMAILFEED: number = 207;
    public static APFEED: number = 208;
    public static FTPFEED: number = 209;

    public static DRAFT: number = 300;
    public static DRAFTSEARCH: number = 301;
    public static ROLIST: number = 400;
    public static LIVESEARCH: number = 401;
    public static PUBLICATION: number = 500;
    public static CASTSEARCH: number = 501;
}

export class MultipleFeedViewStateMode {
    public static NONE: number = 0;
    public static BROWSE: number = 1;
    public static CONFIGURE: number = 2;
}

export enum GeneralViewStateTypesEnums {
    SINGLE = 0,
    SINGLEFEED = 2,
    MULTIPLEFEED = 3,
}

export enum ViewStateTypesEnum {
    SYSTEM = -1,
    TOPIC = 0,
    ASSIGNMENT = 1,
    SEARCH = 2,
    SINGLEITEM = 4,
    SCRIPT = 5,
    WIRE = 200,
    WIRESEARCH = 201,
    SINGLEFEED = 202,
    MULTIPLEFEED = 203,
    RSSFEED = 204,
    TWITTERFEED = 205,
    WIREFEED = 206,
    EMAILFEED = 207,
    APFEED = 208,
    FTPFEED = 209,
    DRAFT = 300,
    DRAFTSEARCH = 301,
    ROLIST = 400,
    LIVESEARCH = 401,
    PUBLICATION = 500,
    CASTSEARCH = 501,
}

export enum MultipleFeedViewStateModeEnum {
    NONE = 0,
    BROWSE = 1,
    CONFIGURE = 2,
}
